import React, { createContext, useState } from 'react';

const CartContext = createContext();

function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState([]);

  const addToCart = (item) => {
    setCartItems((prev) => {
      // Check if item already exists in the cart
      const existingItemIndex = prev.findIndex((cartItem) => cartItem.id === item.id);

      if (existingItemIndex >= 0) {
        // If item exists, increase quantity
        const updatedCart = [...prev];
        updatedCart[existingItemIndex].quantity += item.quantity; // Update quantity
        return updatedCart;
      } else {
        // If item doesn't exist, add it as new with quantity
        return [...prev, { ...item, quantity: item.quantity || 1, addOns: item.addOns}];
      }
    });
  };

  const removeFromCart = (itemId) => {
    setCartItems((prev) => prev.filter((item) => item.id !== itemId));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const generateCartJson = () => {
    return cartItems.map((item) => ({
      product_name: item.title,
      quantity: item.quantity,
      product_id: item.id,
      product_addOns: item.addOns
    }));
  };

  return (
    <CartContext.Provider value={{ cartItems, addToCart, removeFromCart, clearCart, generateCartJson }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return React.useContext(CartContext);
}

export default CartProvider;
